import { useLocation } from '@reach/router'
import React from 'react'

export default function withLocation(Component) {
  return function WrappedComponent(props) {
    const Location = useLocation()
    return <Component {...props} Location={Location} />
  }
}
